import { Action } from '@/lib/frontend/store/actions';
import {
  uninitializedRemoteData,
  unfetchedRemoteData,
  fetchedRemoteData,
  remoteDataError,
  RemoteData,
} from '@/lib/frontend/store/helpers/remoteData';
import { Invoice } from '@/types/invoice';

type FetchedValue = Array<Invoice['Number']>;

export type Invoices = RemoteData<FetchedValue>;

const defaultState = unfetchedRemoteData<FetchedValue>();

export default function invoicesReducer(state: Invoices = defaultState, action: Action): Invoices {
  switch (action.type) {
    case 'FETCH_SESSION_INVOICES_START':
      return unfetchedRemoteData<FetchedValue>();
    case 'FETCH_SESSION_INVOICES_SUCCESS':
      return fetchedRemoteData<FetchedValue>(action.fetchedNumbers);
    case 'FETCH_SESSION_INVOICES_FAIL':
      return remoteDataError<FetchedValue>(action.message);
    case 'FETCH_SESSION_INVOICES_ABORT':
      return uninitializedRemoteData<FetchedValue>();
    case 'SIGN_OUT_SUCCESS':
      return uninitializedRemoteData<FetchedValue>();
    default:
      return state;
  }
}
